var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlobalEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_614_95)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8334 7.00008C12.8334 3.78008 10.2201 1.16675 7.00008 1.16675C3.78008 1.16675 1.16675 3.78008 1.16675 7.00008C1.16675 10.2201 3.78008 12.8334 7.00008 12.8334",
    stroke: "#E0E0E0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66652 1.75H5.24985C4.11235 5.15667 4.11235 8.84333 5.24985 12.25H4.66652",
    stroke: "#E0E0E0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75 1.75C9.31583 3.45333 9.60167 5.22667 9.60167 7",
    stroke: "#E0E0E0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.75 9.33333V8.75C3.45333 9.31583 5.22667 9.60167 7 9.60167",
    stroke: "black",
    strokeOpacity: 0.12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.75 5.2501C5.15667 4.1126 8.84333 4.1126 12.25 5.2501",
    stroke: "#E0E0E0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2065 9.18167L9.1415 11.2467C9.05984 11.3284 8.984 11.48 8.9665 11.5908L8.85567 12.3783C8.81484 12.6642 9.01317 12.8625 9.299 12.8217L10.0865 12.7108C10.1973 12.6933 10.3548 12.6175 10.4307 12.5358L12.4957 10.4708C12.8515 10.115 13.0207 9.70084 12.4957 9.17584C11.9765 8.65667 11.5623 8.82584 11.2065 9.18167Z",
    stroke: "#F45600",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.908 9.47925C11.083 10.1092 11.573 10.5992 12.203 10.7742",
    stroke: "#F45600",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_614_95"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobalEdit);
export default __webpack_public_path__ + "static/media/global-edit.581dc16f6278b67b234734b4f0ef5edb.svg";
export { ForwardRef as ReactComponent };